import { withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card-footer pt-4" }
const _hoisted_2 = { class: "d-flex flex-column w-100" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Send ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(ev => ev.preventDefault(), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          autofocus: "",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSendMessage && _ctx.handleSendMessage(...args)), ["enter"])),
          class: "form-control form-control-flush mb-3",
          placeholder: "Type a message",
          id: _ctx.isDrawer ? 'sendMessageInputDrawer' : 'sendMessageInput',
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.message) = $event))
        }, null, 40, _hoisted_3), [
          [_vModelText, _ctx.data.message]
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        disabled: _ctx.isSending || _ctx.hasMessage,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSendMessage())),
        class: "btn btn-primary",
        type: "submit"
      }, [
        (_ctx.isSending)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
          : _createCommentVNode("", true),
        _hoisted_7
      ], 8, _hoisted_5)
    ])
  ]))
}